import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abc3561e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-np-hero" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "nge-np-id" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-np-kicker" }, "EyeWire II · Chief Guide", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "nge-np-name" }, [
  /*#__PURE__*/_createTextVNode("Nurro "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "nge-np-flag",
    title: "Nationality: the cosmos"
  }, "🐾")
], -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-np-bio" }, "Cream cat. Neuron harness. Has never finished a cell but has supervised thousands. Knows every shortcut and will tell you about them whether or not you asked.", -1 /* HOISTED */))
const _hoisted_7 = { class: "nge-np-badges" }
const _hoisted_8 = { class: "nge-np-grid" }
const _hoisted_9 = { class: "nge-np-stat-icon" }
const _hoisted_10 = { class: "nge-np-stat-value" }
const _hoisted_11 = { class: "nge-np-stat-label" }
const _hoisted_12 = {
  key: 0,
  class: "nge-np-stat-note"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["ModalOverlay"], {
    class: "nge-nurro-profile",
    onHide: _cache[2] || (_cache[2] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "nge-np",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("button", {
          class: "nge-np-close",
          onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide'))),
          "aria-label": "Close"
        }, "×"),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: $setup.nurroJetpack,
            alt: "Nurro in a space suit with a jetpack"
          }, null, 8 /* PROPS */, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.BADGES, (b) => {
                return _createElementVNode("span", {
                  key: b.name,
                  class: "nge-np-badge"
                }, _toDisplayString(b.icon) + " " + _toDisplayString(b.name), 1 /* TEXT */)
              }), 64 /* STABLE_FRAGMENT */))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.STATS, (s, i) => {
            return _createElementVNode("div", {
              key: s.label,
              class: "nge-np-stat"
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(s.icon), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_10, _toDisplayString($setup.shown[i]), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_11, _toDisplayString(s.label), 1 /* TEXT */),
              (s.note)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(s.note), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          }), 64 /* STABLE_FRAGMENT */))
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}